/*************************************************************************
 *
 * c20g CONFIDENTIAL
 * __________________
 *
 *  [2007] - [2021] Counterpoint Consulting, Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Counterpoint Consulting Incorporated.
 * The intellectual and technical concepts contained
 * herein are proprietary to Counterpoint Consulting Incorporated
 * and its suppliers and may be covered by U.S. and Foreign Patents,
 * patents in process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Counterpoint Consulting Incorporated.
 */

import Backbone from 'backbone';

import showErrorMessage from '@/util/showErrorMessage';

import GetCommandPOCsByCommandID from '../services/GetCommandPOCsByCommandID';
import POCGridView from '../views/POCGridView';

export default async function loadPOCGridView(commandID, viewMode) {
  try {
    const data = await GetCommandPOCsByCommandID(commandID);
    return new POCGridView({
      viewMode, // int-new, int-update or ext
      model: new Backbone.Model({
        commandID,
        data
      })
    });
  } catch (err) {
    if (err) {
      showErrorMessage({
        errorCode: 'loadingError',
        errorTitle: 'Loading Error',
        errorMessage: 'An error occurred while loading points of contact. Try again or contact an administrator if your issue persists.'
      });
    }
    return err;
  } finally {
    //finally
  }
}
